// extracted by mini-css-extract-plugin
export default {"container":"people-step_container__Os0hT","content":"people-step_content__prdf8"};